export const languageActions = (type, lang) => ({
  type: type,
  lang: lang
});
